module.exports = __webpack_public_path__ + "SalesforceSans-Light.woff";


//////////////////
// WEBPACK FOOTER
// /home/remy.rodriguez/Hid/env/git/frontend/cloud/webadmin-hmi/node_modules/@salesforce-ux/design-system/assets/fonts/webfonts/SalesforceSans-Light.woff
// module id = ../../../../@salesforce-ux/design-system/assets/fonts/webfonts/SalesforceSans-Light.woff
// module chunks = styles